var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'avatar-header': true, 'up-down-text': _vm.upDownText }},[_c('el-avatar',{staticClass:"av_bg",attrs:{"src":_vm.localUrl,"size":35},on:{"click":_vm.clickAvatar,"error":_vm.errorHandler}},[_c('span',[_vm._v(_vm._s(_vm.text[0]))])]),_c('span',{class:_vm.textDerection},[_vm._v(_vm._s(_vm.resultText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }